/**
 * MATERIAL CUSTOM CODE AT BOTTOM OF THIS FILE - MAKE SURE TO KEEP IT IF UPGRADING THEME
 * 
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Symmetry broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
*   4.  on:cart:after-merge
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - allVariants: an array of all variants
 *  - selectedOptions: an array of currently selected options (e.g. ['Blue', 'Large'])
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:after-merge
 * -------------------------------------------------------------------------------------------------
 * Fires after a list of cart items has finished being dynamically updated after a cart change.
 *
 * How to listen:
 * document.addEventListener('on:cart:after-merge', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Symmetry utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Symmetry has no third-party JavaScript dependencies.
 *
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */

const sizeLookup = {
  "Adult Socks": {
    "M": "Size M Fits: Mens 3.5-8.5 / Womens 5-10",
    "L": "Size L Fits: Mens 8-12 / Womens 10-13",
    "XL": "Size XL Fits: Mens 13-15 / Womens 15-17"
  },
  "Kids Socks": {
    "M": "Size M Fits: Kids Shoe Size 9-2.5",
    "L": "Size L Fits: Kids Shoe Size 3-5"
  },
  "Kids Underwear": {
    "S": "Size S Fits: 24\" Waist",
    "M": "Size M Fits: 25\" Waist",
    "L": "Size L Fits: 26\" Waist",
    "XL": "Size XL Fits: 28\" Waist"
  },
  "Mens Underwear": {
    "XS": "Size XS Fits: 24\"-26\" Waist",
    "S": "Size S Fits: 28\"-30\" Waist",
    "M": "Size M Fits: 30\"-32\" Waist",
    "L": "Size L Fits: 33\"-36\" Waist",
    "XL": "Size XL Fits: 36\"-38\" Waist",
    "XXL": "Size XXL Fits: 39\"-42\" Waist",
    "XXXL": "Size XXXL Fits: 42\"-44\" Waist"
  },
  "Slides": {
    "M": "Size M Fits: Mens 7-9 / Womens 8-10",
    "L": "Size L Fits: Mens 9-11 / Womens 10-12",
    "XL": "Size XL Fits: Mens 11-13 / Womens 12-14"
  },
  "Slippers": {
    "M": "Size M Fits: Mens 7-9 / Womens 8-10",
    "L": "Size L Fits: Mens 9-11 / Womens 10-12",
  },
  "Sports Bras": {
    "S": "Size S Fits: 30C, 32B, 34A",
    "M": "Size M Fits: 32C, 34B, 36A",
    "L": "Size L Fits: 34D, 36C, 38B",
    "XL": "Size XL Fits: 36D, 38C, 40B"
  },
  "Womens Boy Shorts": {
    "S": "Size S Fits: 28-30\" Waist",
    "M": "Size M Fits: 30-32\" Waist",
    "L": "Size L Fits: 33-36\" Waist",
    "XL": "Size XL Fits: 36-38\" Waist"
  }
  // Add more display_size categories as needed
};

function getSizeLabel(sizeType, variant) {
  // Return null if sizeType or variant is missing
  if (!sizeType || !variant) {
    return null;
  }
  
  // Convert to uppercase for case-insensitive comparison
  const upperSizeType = sizeType.toUpperCase();
  const upperVariant = variant.toUpperCase();
  
  // Find the matching size type (case-insensitive)
  const matchingSizeType = Object.keys(sizeLookup).find(key => key.toUpperCase() === upperSizeType);
  
  if (matchingSizeType) {
    // Find the matching variant (case-insensitive)
    const matchingVariant = Object.keys(sizeLookup[matchingSizeType]).find(key => key.toUpperCase() === upperVariant);
    
    if (matchingVariant) {
      return sizeLookup[matchingSizeType][matchingVariant];
    }
  }
  
  // Return null if no match found
  return null;
}

function updateSizeLabel() {
  const variantPicker = document.querySelector('variant-picker');
  const sizeLabelElement = document.querySelector('.size-label');
  
  // Check if required elements exist
  if (!variantPicker || !sizeLabelElement || !variantPicker.selectedOptions || variantPicker.selectedOptions.length < 2) {
    return;
  }
  
  const selectedVariant = variantPicker.selectedOptions[1];
  const sizeType = window.sizeType;
  
  // Get the size label
  const sizeLabel = getSizeLabel(sizeType, selectedVariant);
  
  // Only update if we got a valid size label
  if (sizeLabel) {
    sizeLabelElement.textContent = sizeLabel;
  }
}

document.addEventListener('on:variant:change', (event) => {
  updateSizeLabel();
});

document.addEventListener('DOMContentLoaded', (event) => {
  updateSizeLabel();
});